export default __webpack_public_path__ + "static/media/buzzer - active.e3a8d5a2.png";